export default __webpack_public_path__ + "static/media/cloud-review.4857531b.png";